const About = () => {
    return ( 
        <div className="info-text">
            <h2 className="text">
                Six Degrees of Spotify was devised at a party when the person choosing the music couldn't think of a ceratin
                artist and used the related artist information to find the song he had in mind. A discussion followed about 
                whether the algorithm is useful for finding new music or if it is essentially an 'echo chamber' of the first 
                artist selected. This lead to a competition where guests suggested a target artist that the 'dj' needed to get
                to.<br></br><br></br>

                It's not an easy game. The first attempt took 27 selections...<br></br><br></br><br></br><br></br>
            </h2>
        </div>
     );
}
 
export default About;